












































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import VueQrCode from 'vue-weblineindia-qrcode'
import { RelativeResponse } from '@/api/user/types'
import { Route } from 'vue-router'

@Component({
  components: {
    VueQrCode
  }
})
export default class RelativeIndex extends Vue {
  readonly QR_SIZE = 200
  $store!: ExStore
  createdRelative = {
    ...(this.$store.getters['user/sessionData'](
      'createdRelative'
    ) as RelativeResponse)
  }

  created() {
    if (!this.createdRelative) {
      console.error('Invalid session')
      this.$router.push({ name: 'PatientRelative' })
      return
    }
  }

  handleClickCopy() {
    const range = document.createRange()
    const target = this.$refs.clipboadTarget as HTMLLinkElement
    const selection = window.getSelection() as Selection

    range.selectNodeContents(target)

    selection.removeAllRanges()
    selection.addRange(range)

    document.execCommand('copy')
    selection.removeAllRanges()
    this.$store.dispatch('alert/showMessages', ['コピーしました'])
  }

  async handleClickResend() {
    try {
      const relativeId = this.createdRelative.id
      await this.$api.user.sendMailToRelative({ relativeId })
      this.$store.dispatch('alert/showMessages', ['メールを再送しました。'])
    } catch (error) {
      this.$store.dispatch('alert/showErrorMessages', [
        '送信に失敗しました。しばらくたってからもう一度お試し下さい。'
      ])
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    this.$store.commit('user/deleteSessionData', 'createdRelative')
    next()
  }
}
